import {InfoModal} from "../InfoModal";
import {Utils} from "../Utils";

export class FunModeFeatures {

    public static enableFunModeFeatures(): void {
        FunModeFeatures.enabled = true;
    }

    public static addSpin(): void {
        if (!FunModeFeatures.enabled) {
            return;
        }

        this.spinsMade++;

        if (this.spinsMade % 100 === 0) {
            InfoModal.open("WOW! Someone here is a real player!",
                "Do you want to test your luck and play for real money?", () => {
                    Utils.redirectToCasinoPage();
                }, true,
            );
            InfoModal.setActionButtonText("Login");
        }
    }

    private static enabled = false;
    private static spinsMade = 0;
}



// WEBPACK FOOTER //
// ./src/app/FunModeFeatures/FunModeFeatures.ts